// extracted by mini-css-extract-plugin
export default {"Home_Services":"Home_Services_Home_Services__sROIj","MainBox":"Home_Services_MainBox__BK1hC"};